import React from 'react';

const NoProductsFound = ({ resetFilters }) => {
  return (
    <div className="text-center py-12">
      <svg 
        className="mx-auto h-12 w-12 text-gray-400" 
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor" 
        aria-hidden="true"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
        />
      </svg>
      <h3 className="mt-2 text-sm font-medium text-gray-900">No products found</h3>
      <p className="mt-1 text-sm text-gray-500">Try adjusting your filters or search term.</p>
      <div className="mt-6">
        <button
          onClick={resetFilters}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#174540] hover:bg-[#0d2926]"
        >
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default NoProductsFound;